import { Component, OnInit, Input, Output ,EventEmitter, ViewChild } from '@angular/core';
import {FormControl} from '@angular/forms';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import { Station } from '../models/api_models/station';
import { MatAutocompleteSelectedEvent, MatAutocomplete } from '@angular/material/autocomplete';

@Component({
  selector: 'app-search-station-input',
  templateUrl: './search-station-input.component.html',
  styleUrls: ['./search-station-input.component.scss']
})
export class SearchStationInputComponent implements OnInit {


  private _stations : Station[];
  isStation = "1";
  get stations() : Station[] {
    return this._stations;
  }


@Input()
set stations(stations: Station[]) {
  this._stations = stations;

  if (this._stations && this._stations.length > 0) {

    const firstStation = this.mapStationSelected?.detail
    this.myControl.setValue(firstStation.name);
    // this.stationChanged.emit(firstStation);
  }
}



  @Output() stationChanged  : EventEmitter<Station> = new EventEmitter();
  @Output() addressChanged  : EventEmitter<any> = new EventEmitter();
   
  @ViewChild(MatAutocomplete) matAutocomplete: MatAutocomplete;

  // switchMode(e) {
  //   if (e.checked == 1) {
  //     this.isStation = 1;
  //   } else {
  //     this.isStation = 0;
  //   }
  //}
  
  
  private _mapStationSelected : Station = null;
  get mapStationSelected() : Station {
    return this._mapStationSelected;
  }
  
  @Input()
  set mapStationSelected(mapStationSelected) {
    this._mapStationSelected = mapStationSelected;
    this.isStation = "1";
    if (this._mapStationSelected != null && this._mapStationSelected.name != null){ 
      this.myControl.setValue(this._mapStationSelected.name);
    }
  }

  myControl = new FormControl();
  filteredOptions: Observable<any>;
  selected:string;
  constructor() { }

  ngOnInit() {
    
    this.filteredOptions = this.myControl.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filter(value))
      );
  }

  private _filter(value: string) {
    const filterValue = value.toLowerCase();
 
    console.log( this._stations)
    console.log( this._stations.filter(option => option.name.toLowerCase().includes(filterValue)))
    return this._stations.filter(option => option.name.toLowerCase().includes(filterValue));
  }

  public onAddressChange(event : any) {
    // // conslog(event);
    // // conslog("test");
    
    this.addressChanged.emit(event);
    
  }

  public onStationChanged(event: MatAutocompleteSelectedEvent) {
    // conslog(event.option);
    this._stations.forEach(station => {
      if (station.name == event.option.value) {
        this.stationChanged.emit(station);
        return;
      }
    });

  }

}
